import McInlineForm from './McInlineForm';

export default McInlineForm;
